<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/136Kooc/tc-custom/9783968652955.jpg?1703042209236" alt="This image is the cover for the book The Border Legion, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Border Legion, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The story takes place in the mid 1800's in the Idaho/Montana area. Young and attractive Joan Randall has a spat with her boyfriend, Jim Cleve. The next day she realizes that she was too harsh with him and learns he has left the area. She decides to go after him.  Alone in the rough West, she happens upon an older fellow from town and he decides to help her track Jim. Unfortunately, they encounter outlaws who are lecherous and ruthless. Joan is taken captive by Jack Kells who takes her deep into a secluded canyon where his gang of bandits frequently gather. Kells keeps Joan safely away from the men for which Joan is thankful especially since the mountain of a man, Gulden has a particularly cruel reputation. Also showing up in the canyon is a young man unknown to any of the outlaws but he fits in easily with them. The man is Joan's boyfriend, Jim Cleve. Joan and Jim keep their connection secret. Each of them aware of the danger if they are found out. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zane Grey
      </h2>
      
      <p class="authorDescription body article">Pearl Zane Grey (January 31, 1872 – October 23, 1939) was an American author and dentist best known for his popular adventure novels and stories associated with the Western genre in literature and the arts; he idealized the American frontier. Riders of the Purple Sage (1912) was his best-selling book. In addition to the commercial success of his printed works, his books have had second lives and continuing influence when adapted as films and television productions. His novels and short stories have been adapted into 112 films, two television episodes, and a television series, Dick Powell's Zane Grey Theater.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dd6d4cde